"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return R2;
    }
});
const _clients3 = require("@aws-sdk/client-s3");
const _GenericS3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/GenericS3/GenericS3"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let R2 = class R2 extends _GenericS3.default {
    get defaultParams() {
        return {
            Bucket: this.input.bucket,
            // R2 does not support ACL
            ACL: 'private'
        };
    }
    patchKey(key) {
        return decodeURI(key);
    }
    patchUploadReturnKey(key) {
        // R2 by default encodes the key. But we expect the key to be decoded.
        return decodeURI(key);
    }
    async init() {
        const s3Options = {
            region: 'auto',
            endpoint: this.input.hostname,
            credentials: {
                accessKeyId: this.input.access_key,
                secretAccessKey: this.input.access_secret
            }
        };
        this.s3Client = new _clients3.S3(s3Options);
    }
    getUploadedPath(path) {
        return {
            // bucket in path should already be included in hostname
            url: `${this.input.hostname}/${path}`
        };
    }
    constructor(input){
        super(input), this.name = 'R2';
    }
};
